import type { ImageRequest } from '@imagise/image-processing';
import { applyEditToSize, type EditorCommittedEdit, type EditorSourceImageState } from './editor-domain.models';

export function buildLocalResizePlan(
  source: EditorSourceImageState,
  edits: readonly EditorCommittedEdit[],
  outputFormat: string
): Omit<ImageRequest, 'bytes'> | null {
  const edit = edits.length === 1 ? edits[0] : null;
  if (
    edit?.kind !== 'resize' ||
    !isPositiveFinite(source.width) ||
    !isPositiveFinite(source.height) ||
    (source.mimeType !== 'image/png' && source.mimeType !== 'image/jpeg')
  ) {
    return null;
  }

  const resolvedOutputFormat = outputFormat === 'PNG' ? 'image/png' : outputFormat === 'JPG' ? 'image/jpeg' : null;
  if (!resolvedOutputFormat) {
    return null;
  }

  const size = applyEditToSize({ width: source.width, height: source.height }, edit);
  if (!isPositiveFinite(size.width) || !isPositiveFinite(size.height)) {
    return null;
  }

  return {
    inputFormat: source.mimeType,
    outputFormat: resolvedOutputFormat,
    operation: { type: 'resize', ...size },
  };
}

function isPositiveFinite(value: number | null): value is number {
  return typeof value === 'number' && Number.isFinite(value) && value > 0;
}
